import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../utils/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [devResetLink, setDevResetLink] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setDevResetLink(null);
    try {
      const res = await authAPI.forgotPassword(email.trim().toLowerCase());
      if (res.data?.success) {
        setSubmitted(true);
        if (res.data?.data?.reset_link) setDevResetLink(res.data.data.reset_link);
      }
    } catch (err) {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-dark p-6">
      <div className="text-center mb-8 mt-8">
        <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-dark font-bold text-xl">V</span>
        </div>
        <h1 className="text-2xl font-bold text-gold mb-2">Reset Password</h1>
        <p className="text-light">Enter your email to receive a reset link</p>
      </div>

      <div className="flex-1">
        {submitted ? (
          <div className="bg-gray-800 rounded-xl p-6 text-center">
            <p className="text-light mb-4">
              If an account exists for <strong className="text-gold">{email}</strong>, you will receive a password reset link shortly.
            </p>
            <p className="text-gray-400 text-sm mb-6">Check your inbox and spam folder.</p>
            {devResetLink && (
              <p className="text-xs text-gray-500 mb-4 break-all">Dev: <a href={devResetLink} className="text-gold underline">Reset link</a></p>
            )}
            <Link
              to="/auth/patient/login"
              className="inline-block bg-gold text-dark font-semibold py-3 px-6 rounded-lg hover:opacity-90"
            >
              Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-light text-sm font-medium mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-gray-900 rounded-lg px-4 py-3 text-light focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent"
                placeholder="Enter your email"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gold text-dark font-semibold py-3 px-4 rounded-lg hover:bg-opacity-90 transition-colors disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        )}
      </div>

      <div className="text-center py-6">
        <Link to="/auth/patient/login" className="text-gold font-medium text-sm">
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
